import axios from 'axios';
import { API_ENDPOINT } from '../configurations/global.config';
import { BranchRecommendationResponse } from '../interfaces/delivery-company/orders';
import { Workflow } from '../enums/orders';

export interface RecommendBranchParams {
  workflow: Workflow;
  customer_location_id?: number | null;
  merchant_location_id?: number | null;
}

/**
 * Fetches branch recommendation from the backend based on workflow and locations
 * @param params - The workflow and location parameters
 * @param config - Axios config with auth headers (from AuthContext)
 * @returns Promise with branch recommendation response
 */
export const fetchBranchRecommendation = async (
  params: RecommendBranchParams,
  config?: any
): Promise<BranchRecommendationResponse> => {
  const endpoint = `${API_ENDPOINT}/api/v1/orders/recommend-branch/`;
  
  const response = await axios.post<BranchRecommendationResponse>(
    endpoint,
    params,
    config
  );
  
  return response.data;
};

